import React, { useState } from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";
import { Link } from "react-router-dom";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // 清除该字段的错误信息
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // 验证邮箱格式
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // 验证所有字段并返回错误信息
  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.subject) {
      newErrors.subject = "Please select a subject";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 验证表单
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      // 滚动到第一个错误字段
      const firstErrorField = Object.keys(formErrors)[0];
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    // 模拟表单提交
    setTimeout(() => {
      setShowSuccess(true);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
      setIsSubmitting(false);

      // 滚动到顶部显示成功消息
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 1000);
  };
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="contact">
      <Header />

      <main className="contact-content">
        <div className="breadcrumb">
          <Link to="/" onClick={toTop}>
            Home
          </Link>
          <span className="separator">&rsaquo;</span>
          <span className="current">Contact Us</span>
        </div>

        {showSuccess && (
          <div className="success-message">
            Your message has been sent successfully! We'll get back to you soon.
          </div>
        )}

        <section className="hero-banner">
          <h1>
            We're All Ears! <i className="fa-solid fa-paw paw-icon"></i>
          </h1>
          <p>
            Whether you have a question about our slow feeders, want to share a
            cute photo of your pup, or just want to say "Woof", we'd love to
            hear from you.
          </p>
        </section>

        <section className="contact-grid">
          <div className="contact-info-card">
            <h2>Get in Touch</h2>

            <div className="info-item">
              <div className="icon-wrapper">
                <i className="fa-solid fa-location-dot"></i>
              </div>
              <div className="info-content">
                <h3>Address</h3>
                <p>
                  Pawluna
                  <br />
                  60 Harris Rd
                  <br />
                  Mineral Bluff, GA 30559 US
                </p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon-wrapper">
                <i className="fa-regular fa-envelope"></i>
              </div>
              <div className="info-content">
                <h3>Send a Note</h3>
                <a href="mailto:many@pawluna.art">many@pawluna.art</a>
              </div>
            </div>
          </div>

          <div className="contact-form-card">
            <h2>Send us a Message</h2>
            <p className="form-subtitle">
              Got a question? Fill out the form below and we'll get back to you
              asap.
            </p>

            {showSuccess ? (
              <div
                className="success-message"
                style={{
                  marginTop: "20px",
                  padding: "30px 20px",
                  backgroundColor: "#f0fdf4",
                  border: "1px solid #bbf7d0",
                  borderRadius: "12px",
                  textAlign: "center",
                }}
              >
                <i
                  className="fa-solid fa-circle-check"
                  style={{
                    fontSize: "48px",
                    color: "#22c55e",
                    marginBottom: "15px",
                  }}
                ></i>
                <h3
                  style={{
                    color: "#166534",
                    margin: "0 0 10px 0",
                    fontSize: "20px",
                  }}
                >
                  Thank You!
                </h3>
                <p style={{ color: "#15803d", margin: 0 }}>
                  Your message has been successfully sent. We will get back to
                  you as soon as possible.
                </p>
                <button
                  onClick={() => setShowSuccess(false)}
                  style={{
                    marginTop: "20px",
                    padding: "10px 24px",
                    backgroundColor: "#3b82f6",
                    color: "white",
                    border: "none",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">
                      Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      className={errors.firstName ? "error-input" : ""}
                    />
                    {errors.firstName && (
                      <span className="error-text">{errors.firstName}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">
                      Email Address <span className="required">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={errors.email ? "error-input" : ""}
                    />
                    {errors.email && (
                      <span className="error-text">{errors.email}</span>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">
                    Topic <span className="required">*</span>
                  </label>
                  <div className="select-wrapper">
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className={errors.subject ? "error-input" : ""}
                    >
                      <option value="" disabled>
                        Select a topic...
                      </option>
                      <option value="Customer Service">Customer Service</option>
                      <option value="Product Inquiry">Product Inquiry</option>
                      <option value="Wholesale/Trade">Wholesale/Trade</option>
                      <option value="Other">Other</option>
                    </select>
                    <i className="fa-solid fa-chevron-down select-icon"></i>
                  </div>
                  {errors.subject && (
                    <span className="error-text">{errors.subject}</span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="message">
                    Message <span className="required">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                    className={errors.message ? "error-input" : ""}
                  ></textarea>
                  {errors.message && (
                    <span className="error-text">{errors.message}</span>
                  )}
                </div>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Send"}
                </button>
              </form>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
